<!--
  +---------------------------------------------------------------------------------------
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     账户中心-收货地址
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="fam-address-list mt-md">
    <el-card shadow="never" class="mb-md">
      <f-god-address-picker :radio="false" />
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'FamAddressList',

  components: {
    FGodAddressPicker: () => import('./components/FGodAddressPicker'),
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  methods: {
  }
}
</script>
